/**
 * SponsoredSearchAnswer — a thin banner ad injected at a stable
 * random position inside the homepage search results (not pinned to
 * the top). See `advertisingService.findSponsoredAnswer()` for the
 * relevance + state + probability matching logic.
 *
 * Visual language:
 *   • Reuses SponsoredCard chrome so it inherits the "Ad" label,
 *     click tracking, impression firing, session cap — one ad look
 *     across every surface.
 *   • Wrapped in a smaller container with generous horizontal
 *     whitespace so the banner doesn't dominate the dropdown row
 *     rhythm. Right-column dropdown space (icons + arrows) still
 *     lines up with the organic rows above/below.
 */
import React from 'react';
import SponsoredCard from '../ads/SponsoredCard';

const SponsoredSearchAnswer = ({ ad }) => {
  if (!ad) return null;
  return (
    <div
      className="px-8 sm:px-12 py-2 my-1 bg-white"
      data-testid={`sponsored-search-answer-${ad.id}`}
    >
      <div className="max-w-[380px] mx-auto">
        <SponsoredCard
          ad={ad}
          surface="search-sponsored-answer"
          size="small"
          className="rounded-lg overflow-hidden"
        />
      </div>
    </div>
  );
};

export default SponsoredSearchAnswer;
